import React, { useState, forwardRef } from 'react';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { Eye, EyeOff } from 'lucide-react';

/**
 * PasswordInput — Input with an eye toggle to reveal/hide the value.
 * Accepts all standard Input props. `data-testid` should be provided by the caller.
 */
export const PasswordInput = forwardRef(function PasswordInput(
  { className = '', ...props }, ref
) {
  const [show, setShow] = useState(false);
  return (
    <div className='relative'>
      <Input
        ref={ref}
        type={show ? 'text' : 'password'}
        autoComplete={props.autoComplete || 'current-password'}
        className={`pr-10 ${className}`}
        {...props}
      />
      <Button
        type='button'
        variant='ghost'
        size='sm'
        aria-label={show ? 'Hide password' : 'Show password'}
        onClick={() => setShow((v) => !v)}
        className='absolute right-1 top-1/2 -translate-y-1/2 h-7 w-7 p-0 text-muted-foreground hover:text-foreground'
        data-testid={props['data-testid'] ? `${props['data-testid']}-toggle` : 'password-toggle'}
        tabIndex={-1}
      >
        {show ? <EyeOff className='h-4 w-4' /> : <Eye className='h-4 w-4' />}
      </Button>
    </div>
  );
});

export default PasswordInput;
